import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";

export default function AppTemplatesPage() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    api.get("/templates").then((r) => setItems(r.data));
  }, []);

  const use = async (id) => {
    setBusy(id); setErr("");
    try {
      const { data } = await api.post(`/templates/${id}/use`);
      nav(`/app/surveys/${data.id}`);
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setBusy(""); }
  };

  return (
    <div className="space-y-5 fade-in">
      <p className="text-slate-600">Pre-built surveys to launch in seconds.</p>
      {err && <p className="text-sm text-rose-600">{err}</p>}
      <div className="grid md:grid-cols-3 gap-5">
        {items.map((t) => (
          <Card key={t.id} data-testid={`app-tpl-${t.id}`} className="p-5 border-slate-100 hover:shadow-elev-2 transition-shadow flex flex-col">
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-extrabold text-[#1F3A6B] text-lg leading-tight">{t.title}</h3>
              <Badge variant="outline" className="text-[10px] uppercase bg-[#FFF0DF] text-[#F58220] border-[#FFE1BE]">{t.category}</Badge>
            </div>
            <p className="mt-2 text-sm text-slate-600">{t.description}</p>
            <div className="mt-3 text-xs text-slate-500">{t.questions?.length || 0} questions · {t.industry}</div>
            <Button data-testid={`app-tpl-use-${t.id}`} onClick={() => use(t.id)} disabled={busy === t.id} className="mt-auto bg-[#F58220] hover:bg-[#E36F0E] text-white">
              {busy === t.id ? "Creating…" : "Use template"}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
